
import { Platform } from 'react-native';

export const colors = {
  bg: '#0A0A0B',
  card: '#151517',
  cardHi: '#1D1E21',
  border: '#26272B',
  borderSoft: '#1C1D20',
  text: '#FFFFFF',
  dim: '#8A8C93',
  faint: '#57595F',
  gold: '#F2CB4E',
  red: '#FF5C5C',
  green: '#5BE3B0',
  onGold: '#12100A',
} as const;

export const radius = {
  sm: 10,
  md: 16,
  lg: 22,
  pill: 999,
} as const;

/**
 * The headline face. iOS `system-ui` at weight 800 gets close to the tight,
 * heavy grotesque in the reference screens without shipping font files.
 */
export const fontFamily = Platform.select({
  ios: { display: 'system-ui', mono: 'ui-monospace' },
  web: {
    display: 'Inter, ui-sans-serif, system-ui, -apple-system, sans-serif',
    mono: 'ui-monospace, SFMono-Regular, Menlo, monospace',
  },
  default: { display: undefined as string | undefined, mono: 'monospace' },
})!;

export const type = {
  display: {
    fontFamily: fontFamily.display,
    fontWeight: '800' as const,
    letterSpacing: -1.2,
  },
  title: {
    fontFamily: fontFamily.display,
    fontWeight: '800' as const,
    letterSpacing: -0.6,
  },
  body: {
    fontFamily: fontFamily.display,
    fontWeight: '500' as const,
  },
  /** All-caps micro label with wide tracking — used everywhere in the UI. */
  label: {
    fontFamily: fontFamily.display,
    fontWeight: '600' as const,
    letterSpacing: 2,
    fontSize: 11,
  },
} as const;

export const MAX_WIDTH = 520;
